import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

export function SortableMatchRow({ match, index, children, isDragEnabled }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: match.id, disabled: !isDragEnabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    backgroundColor: isDragging ? '#f1f5f9' : undefined,
  };

  return (
    <tr ref={setNodeRef} style={style} className="table-row-hover" data-testid={`match-row-${index}`}>
      {isDragEnabled && (
        <td className="px-2 py-3 w-8">
          <button
            {...attributes}
            {...listeners}
            className="cursor-grab active:cursor-grabbing text-slate-400 hover:text-slate-600 p-1"
            data-testid={`drag-handle-${index}`}
          >
            <GripVertical className="w-4 h-4" />
          </button>
        </td>
      )}
      {children}
    </tr>
  );
}
